import React from "react";
import {
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuList,
  Spacer,
  Text
} from "@chakra-ui/react";
import { IconType } from "react-icons/lib";
import { MdArrowForwardIos } from "react-icons/md";

interface MenuProps {
  menuList: React.ReactElement;
  buttonName: string;
  buttonIcon: IconType;
}

const ExportMenu: React.FC<MenuProps> = ({
  menuList,
  buttonIcon,
  buttonName
}) => {
  const [opened, setOpened] = React.useState(false);

  return (
    <Menu
      isOpen={opened}
      onOpen={() => setOpened(true)}
      placement="left"
      closeOnSelect={false}
      onClose={() => setOpened(false)}
      autoSelect={false}
    >
      <MenuButton
        _hover={{ background: "gray.100" }}
        _active={{ background: "gray.200" }}
        w="100%"
        p="6px 12px"
        fontSize="sm"
      >
        <Flex align="center" columnGap="12px">
          <Icon as={buttonIcon} size="12px" />
          <Text>{buttonName}</Text>
          <Spacer />
          <MdArrowForwardIos size="12px" />
        </Flex>
      </MenuButton>

      <MenuList>{menuList}</MenuList>
    </Menu>
  );
};

export default ExportMenu;
